import TrendDown from '@clearkit/icons/glyphs/TrendDown';
import TrendUp from '@clearkit/icons/glyphs/TrendUp';
import capitalize from 'lodash/capitalize';
import { useQuery } from '@apollo/client';
import enrichmentMetricsQuery from "./enrichmentHealthMetric.graphql"
import moment, {Moment}  from 'moment';
import SpinnerMono from '@clearkit/icons/indicators/SpinnerMono';

const successColor = 'green-600';
const dangerColor = 'red';


type EnrichmentMetricProps = {
  metricName: string;
  clearbitAccountId: string;
  externalType: "hubspot"| "salesforce" |"marketo";
  queryStartDate: Moment;
};
function EnrichmentMetric({ metricName , clearbitAccountId, externalType, queryStartDate}: EnrichmentMetricProps) {
  const duration = moment().diff(queryStartDate, "days");
  const { data: { enrichmentHealthMetric: currentRangeMetric } = {}, loading: currentRangeLoading } = useQuery(
    enrichmentMetricsQuery,
    {
      fetchPolicy: 'no-cache',
      variables: {
        clearbitAccountId: clearbitAccountId,
        metricName: metricName,
        externalType: externalType,
        startDate: queryStartDate.utc().format("YYYY-MM-DD"),
        endDate: moment().utc().format("YYYY-MM-DD")

      },
    },
  );
  const pastEndDate = moment(queryStartDate).add(-1, 'days')
  const pastStartDate = moment(pastEndDate).add(-duration, 'days')
  const { data: { enrichmentHealthMetric: pastRangeMetric } = {}, loading: pastRangeLoading } = useQuery(
    enrichmentMetricsQuery,
    {
      variables: {
        fetchPolicy: 'no-cache',
        clearbitAccountId: clearbitAccountId,
        metricName: metricName,
        externalType: externalType,
        startDate: pastStartDate.utc().format("YYYY-MM-DD"),
        endDate: pastEndDate.utc().format("YYYY-MM-DD")

      },
    },
  );
  const trendingUp = currentRangeMetric?.uniques >= pastRangeMetric?.uniques
  return (
    <>
      <div className="flex flex-row">
        {currentRangeLoading ? 
          <SpinnerMono/> :
          <div className="font-semibold">
            {currentRangeMetric?.uniques}
          </div>
          }
        <div
          className={`ml-1 text-${
            trendingUp ? successColor  : dangerColor
          }`}>
          {currentRangeLoading || pastRangeLoading ?
           <SpinnerMono/> :
           <div className="flex flex-row">
            {trendingUp ? <TrendUp /> :  <TrendDown /> }
            {pastRangeMetric?.uniques}
          </div>
          }
      
        </div>
      </div>
      <div className="text-xs">{metricDisplayName(metricName)}</div>
    </>
  );
}

const metricNameMap : {[unique_records_enriched: string]: string} = {
  unique_records_enriched: 'Records enriched',
};

function metricDisplayName(metricName: string ) : string {
  if (metricNameMap[metricName]) {
    return metricNameMap[metricName];
  }
  // error_rate -> Error rate
  const uncapitalizedString = metricName.split('_').join(' ');
  return capitalize(uncapitalizedString);
}

export default EnrichmentMetric;
